module.exports = __webpack_public_path__ + "img/usPowerBall_icon.9a966f3b.png";